// extracted by mini-css-extract-plugin
export default {"productGallery":"vH-z","infoAboveGallery":"wH-z","inQuickShop":"xH-z"};